module.exports = __webpack_public_path__ + "img/icon-use-secureship-gray.a1878a50.svg";